export default __webpack_public_path__ + "images/think-green.c7160006.png";